// extracted by mini-css-extract-plugin
module.exports = {"blueCard":"usps_blueCard__Q0Koh"};